module.exports = __webpack_public_path__ + "static/media/loola-social-promo-image-v2.c66f6a50.svg";